export interface Phone {
    label: string
    value: string
}

export interface ContactsPerson {
    pictureURL?: string
    role: string
    name: string
    phone: Phone
    email: string
}

export interface ContactsCompany {
    pictureURL?: string
    name: string
    street: string
    city: string
    country: string
    nip: string
    website: string
    phone: Phone
    email: string
}

export interface ContactsPage {
    persons: ContactsPerson[]
    companies: ContactsCompany[]
}

export var callPageContacts: ContactsPage = {
    persons: [],
    companies: [{
        // pictureURL: '/public/env/img/logo/logo.png',
        name: 'Grupa PGS Sp. z o.o.',
        street: 'ul. Męczenników Majdanka 74K',
        city: '20-325 Lublin',
        country: 'Polska',
        nip: '7123219604',
        website: 'grupa-pgs.pl',
        phone: {
            label: '667 448 799',
            value: '667448799'
        },
        email: 'biuro@grupa-pgs.pl'
    }]
}

export var machineRentPageContacts: ContactsPage = {
    persons: [],
    companies: [{
        // pictureURL: '/public/env/img/logo/logo.png',
        name: 'Grupa PGS Sp. z o.o.',
        street: 'ul. Męczenników Majdanka 74K',
        city: '20-325 Lublin',
        country: 'Polska',
        nip: '7123219604',
        website: 'grupa-pgs.pl',
        phone: {
            label: '667 880 773',
            value: '667880773'
        },
        email: 'serwis@grupa-pgs.pl'
    }]
}

export var machineBuyPageContacts: ContactsPage = machineRentPageContacts

export var supportPageContacts: ContactsPage = {
    persons: [{
        pictureURL: '/public/env/img/contact/marcin-skibinski.png',
        name: 'Marcin Skibiński',
        role: 'Super Administrator',
        phone: {
            label: '+48 519 343 232',
            value: '+48519343232'
        },
        email: 'marcin@evoltag.pl'
    }],
    companies: []
}